import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderTestimonial() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 5500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@0.75': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.50': {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >

                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-prev">
                        <div className="testimonial-item-prime">
                            <div className="testimonial-item-header-prime">
                                <div className="testimonial-item-rating-prime">
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                </div>
                                <div className="testimonial-item-content-prime" >
                                    <p style={{ textAlign: "justify" }}>“Solar World Enterprises provided an excellent solar installation experience from consultation to completion. Their team explained the system clearly, helped us choose the right solution, and completed the installation professionally. We are very happy with the overall service.”</p>
                                </div>
                            </div>
                            <div className="testimonial-author-prime">
                                <div className="testimonial-author-image-prime">
                                    <figure className="image-anime" >
                                        <img src="./assets/solar/Profile.png" alt />
                                    </figure>
                                </div>
                                <div className="testimonial-author-content-prime">
                                    <h3>— Residential Customer</h3>
                                    {/* <p>Industrial Client</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-prev">
                        <div className="testimonial-item-prime">
                            <div className="testimonial-item-header-prime">
                                <div className="testimonial-item-rating-prime">
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                </div>
                                <div className="testimonial-item-content-prime" >
                                    <p style={{ textAlign: "justify" }}>“We were impressed with the professionalism and technical knowledge of the Solar World Enterprises team. They understood our energy requirements and provided a solution that suited our needs. The entire process was smooth and well-managed.”</p>
                                </div>
                            </div>
                            <div className="testimonial-author-prime">
                                <div className="testimonial-author-image-prime">
                                    <figure className="image-anime" >
                                        <img src="./assets/solar/Profile.png" alt />
                                    </figure>
                                </div>
                                <div className="testimonial-author-content-prime">
                                    <h3>— Business Customer</h3>
                                    {/* <p>Industrial Client</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-prev">
                        <div className="testimonial-item-prime">
                            <div className="testimonial-item-header-prime">
                                <div className="testimonial-item-rating-prime">
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                </div>
                                <div className="testimonial-item-content-prime" >
                                    <p style={{ textAlign: "justify" }}>“Installing a solar system has been a valuable step for our business. The team at Solar World Enterprises guided us throughout the project and ensured everything was properly installed. Their service and support have been excellent.”</p>
                                </div>
                            </div>
                            <div className="testimonial-author-prime">
                                <div className="testimonial-author-image-prime">
                                    <figure className="image-anime" >
                                        <img src="./assets/solar/Profile.png" alt />
                                    </figure>
                                </div>
                                <div className="testimonial-author-content-prime">
                                    <h3>— Commercial Client</h3>
                                    {/* <p>Industrial Client</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-prev">
                        <div className="testimonial-item-prime">
                            <div className="testimonial-item-header-prime">
                                <div className="testimonial-item-rating-prime">
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                </div>
                                <div className="testimonial-item-content-prime" >
                                    <p style={{ textAlign: "justify" }}>“The team was responsive, professional, and helpful throughout the solar installation process. They answered all our questions and made the entire experience simple and convenient. We would definitely recommend Solar World Enterprises.”</p>
                                </div>
                            </div>
                            <div className="testimonial-author-prime">
                                <div className="testimonial-author-image-prime">
                                    <figure className="image-anime" >
                                        <img src="./assets/solar/Profile.png" alt />
                                    </figure>
                                </div>
                                <div className="testimonial-author-content-prime">
                                    <h3>— Satisfied Customer</h3>
                                    {/* <p>Industrial Client</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-prev">
                        <div className="testimonial-item-prime">
                            <div className="testimonial-item-header-prime">
                                <div className="testimonial-item-rating-prime">
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                </div>
                                <div className="testimonial-item-content-prime" >
                                    <p style={{ textAlign: "justify" }}>“We wanted to adopt renewable energy for our property, and Solar World Enterprises helped us understand the available options. Their customized approach and professional service gave us confidence in our investment.”</p>
                                </div>
                            </div>
                            <div className="testimonial-author-prime">
                                <div className="testimonial-author-image-prime">
                                    <figure className="image-anime" >
                                        <img src="./assets/solar/Profile.png" alt />
                                    </figure>
                                </div>
                                <div className="testimonial-author-content-prime">
                                    <h3>— Homeowner</h3>
                                    {/* <p>Industrial Client</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-prev">
                        <div className="testimonial-item-prime">
                            <div className="testimonial-item-header-prime">
                                <div className="testimonial-item-rating-prime">
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                    <i className="fa-solid fa-star" />
                                </div>
                                <div className="testimonial-item-content-prime" >
                                    <p style={{ textAlign: "justify" }}>“From initial consultation and system planning to installation and final testing, Solar World Enterprises handled everything professionally. Their attention to detail and customer-focused approach made the project much easier for us.”</p>
                                </div>
                            </div>
                            <div className="testimonial-author-prime">
                                <div className="testimonial-author-image-prime">
                                    <figure className="image-anime" >
                                        <img src="./assets/solar/Profile.png" alt />
                                    </figure>
                                </div>
                                <div className="testimonial-author-content-prime">
                                    <h3>— Institutional Client</h3>
                                    {/* <p>Industrial Client</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>







            </Swiper>
        </>
    );
}
